//
// This file is auto generated. See ./README.md for details
//
import React from 'react'
import { Icon as ChakraIcon } from '@chakra-ui/react'
import {
  HubResponsiveValue,
  StandardIconSizes,
  HubStyleObject,
  forwardRef,
} from '@hub/design-system-base'
import { FoodAndDrinkLargeSVG } from './svg'

interface FoodAndDrinkLargeIconProps {
  boxSize?: HubResponsiveValue<StandardIconSizes>
  sx?: HubStyleObject
}

export const FoodAndDrinkLargeIcon: React.FC<FoodAndDrinkLargeIconProps> = forwardRef<
  FoodAndDrinkLargeIconProps,
  typeof ChakraIcon
>(({ boxSize = 'size-icon-sm', sx }, ref) => (
  <ChakraIcon ref={ref} boxSize={boxSize} as={FoodAndDrinkLargeSVG} sx={sx} />
))
